import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import packageJson from '../package.json';
import AppLayout from './components/appLayout';
import Fevicon from "./assets/Favicon.png"
function Meta({ name }) {
  return (
    <Helmet>
      <title>Wday - Snapshot {name}</title>
      <meta name="title" content="" data-react-helmet="true" />
      <meta name="description" content="App Description" data-react-helmet="true" />
      <link rel="icon" href={Fevicon} />
      <meta name="theme-color" content="#008f68" data-react-helmet="true" />
    </Helmet>
  )
}
export default Meta;